import React, { useState } from 'react'
import { DeployStatus, Tenant } from '../../Interfaces/Types'
import Button2 from '@embracesbs/component-button2/Button2'
import Icon from '@embracesbs/component-icon/Icon'
import { useApi } from '../../Hooks'

interface SupportLoginQuickButtonDetailsProps {
  tenant?: Tenant
}

const SupportLoginQuickButton: React.FC<SupportLoginQuickButtonDetailsProps> = ({ tenant }) => {
  const { fetchApi } = useApi()
  const [isLoading, setIsLoading] = useState(false)

  const canUpdate = (state?: DeployStatus) => {
    if (state === 'finished' || state === 'supportLoading') {
      return true
    }

    return false
  }

  const handleSupportLogin = () => {
    if (tenant !== undefined) {
      setIsLoading(true)
      fetchApi({
        endpoint: `/api/tenant/${tenant?.id}/tenantsconfiguration/supporturl`,
        method: 'GET'
      })
        .then((data) => {
          const loginUrl = data?.loginUrl
          const keycloakUrl = data?.keycloakUrl

          if (!loginUrl) {
            throw new Error('loginUrl is missing from the response')
          }

          if (!keycloakUrl) {
            throw new Error('keycloakUrl is missing from the response')
          }

          const supportUrl = `${keycloakUrl}/auth/realms/${tenant?.tenantName}/protocol/openid-connect/auth?client_id=embracecloud&redirect_uri=${loginUrl}&response_type=code&scope=openid+suite-user+identity-provider-user&kc_idp_hint=support`
          window.open(supportUrl, '_blank', 'noopener,noreferrer')
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  return (
    <>
      {canUpdate(tenant?.deployStatus) ? (
        <Button2
          buttonSize='30px'
          style={{ borderRadius: '8px' }}
          leftElement={<Icon iconName='CreatedByMe' size={14} color='var(--tma-accent)' />}
          tabIndex={-1}
          onClick={handleSupportLogin}
          isLoading={isLoading}
          text=''
          tooltip='Open support login'
          type='button'
          variant='outlined'
        />
      ) : null}
    </>
  )
}

export default SupportLoginQuickButton
